import { render, staticRenderFns } from "./organization-nav-bar.vue?vue&type=template&id=3868a315&scoped=true&"
import script from "./organization-nav-bar.vue?vue&type=script&lang=js&"
export * from "./organization-nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./organization-nav-bar.vue?vue&type=style&index=0&id=3868a315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868a315",
  null
  
)

export default component.exports